import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, SalesOrderLine, TmsWebBaseEditService } from 'tms-lib';
import { UpdateShippedOrder } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class UpdateShippedOrderService extends TmsWebBaseEditService<SalesOrderLine, UpdateShippedOrder> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('UpdateShippedOrder', $localize`Update Shipped Order`, httpService, notificationService);
  }

  updateShippingDetails(ids: string[], trackingNumbers: string[], shipperIds: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateShippingDetails`, { ids, trackingNumbers, shipperIds });
  }
}
